import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@sharedenvironment';

export class NeqTranslateLoader implements TranslateLoader {
  /** The first successfull response received from the API request */
  successfulResponse: any;
  lastLang: string;

  constructor(private httpClient: HttpClient) { }

  public getTranslation(lang: string): Observable<any> {
    if (this.successfulResponse && this.lastLang == lang) {
      // If there was at least one succesful response with the translation
      // then do not ask it several times and return this respons
      return of(this.successfulResponse);
    }
    // If there was not any successfull response with the translations then ask a new one
    return new Observable((observer: any) => {
      const headers = new HttpHeaders({
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
      });
      headers.set('Api-Key', environment.technical.apiKey);
      this.httpClient.get(`${environment.translate.url}?lang=${lang}`, { headers: headers }).subscribe((json) => {
        observer.next(json);
        // Set the successfull response with the response of the API.
        // It allows us to do not request several time the translations
        this.successfulResponse = json;
        this.lastLang = lang;
        observer.complete();
      });
    });
  }
}
